export enum RelevanceEnum {
  Primary,
  Secondary
}

export interface IActionButton {
  label: string;
  relevance: RelevanceEnum;
  handler: () => void;
}
